/**
 * Notification endpoints.
 */
import type {
  NotificationInboxResponse,
  NotificationPreferences,
  NotificationPreferencesUpdate,
} from '@/types/api';
import { apiClient } from './client';

export const notificationApi = {
  getPreferences: () =>
    apiClient.get<NotificationPreferences>(
      '/users/me/notification-preferences'
    ),

  updatePreferences: (data: NotificationPreferencesUpdate) =>
    apiClient.put<NotificationPreferences>(
      '/users/me/notification-preferences',
      data
    ),

  getInbox: (limit = 20) =>
    apiClient.get<NotificationInboxResponse>(
      `/notifications/inbox?limit=${limit}`
    ),

  markRead: (id: string) =>
    apiClient.patch<{ id: string; read_at: string }>(
      `/notifications/${id}/read`
    ),

  markAllRead: () =>
    apiClient.patch<{ updated: number }>('/notifications/read-all'),
};

// Exports
